/*
 * CANALE SUBTERANE — Scroll Reveal
 * Lightweight IntersectionObserver. Zero dependencies.
 *
 * Usage: add data-reveal (and optionally data-reveal-delay="200") to any element.
 * Elements start invisible; get class .cs-revealed when entering viewport.
 * CSS handles the actual animation via .cs-revealed transitions.
 */

(function () {
  'use strict';

  var CSS = [
    '[data-reveal]{opacity:0;transform:translateY(28px);transition:opacity 600ms cubic-bezier(0.4,0,0.2,1),transform 600ms cubic-bezier(0.4,0,0.2,1);}',
    '[data-reveal="left"]{transform:translateX(-32px);}',
    '[data-reveal="right"]{transform:translateX(32px);}',
    '[data-reveal="scale"]{transform:scale(0.94);}',
    '[data-reveal="fade"]{transform:none;}',
    '.cs-revealed{opacity:1!important;transform:none!important;}'
  ].join('');

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  if (!('IntersectionObserver' in window)) {
    /* Fallback: show everything immediately */
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('cs-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.dataset.revealDelay, 10) || 0;
      if (delay) {
        setTimeout(function () { el.classList.add('cs-revealed'); }, delay);
      } else {
        el.classList.add('cs-revealed');
      }
      observer.unobserve(el);
    });
  }, {
    rootMargin: '0px 0px -60px 0px',
    threshold: 0.08
  });

  function observe() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
